import styled, { css } from "styled-components";
import { Image as AntImage, Space, Input as AntInput, Row } from "antd";
import { ADMIN_LK } from "@constants";

export const RootContainer = styled.div`
  padding: 0;
  height: calc(100vh - 70px);
  overflow: hidden;
`;

export const EmptyText = styled.div`
  font-size: 13px;
  height: calc(100vh - 461px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-height: 800px) {
    height: calc(100vh - 366px);
  }
`;

export const Container = styled.div.attrs({
  id: "scrollableDiv",
})`
  /* padding: 0 5px; */
  /* border: 10px solid green; */
  width: 100%;
  height: calc(100vh - 290px);
  padding-bottom: 12px;
  overflow: auto;

  @media screen and (max-width: 347px) {
    height: calc(100vh - 283px);
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DateText = styled.div`
  padding: 14px 0;
  font-size: 12px;
  font-weight: normal;
  color: #00367580;
  text-align: center;
`;

export const NameText = styled.div`
  padding-right: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #004F9C;
  text-align: left;
`;

export const TimeText = styled.div`
  font-size: 10px;
  font-weight: normal;
  color: ${(props) =>
    props.sender === ADMIN_LK ? "#00367580" : "#000000"};
  display: flex;
  justify-content: ${(props) =>
    props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
`;

export const MessageText = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  width: fit-content;
  max-width: 250px;
  padding: 8px 14px;
  border-radius: 12px;

  font-size: 13px;
  font-weight: 500;
  line-height: 25px;
  color: ${(props) =>
    props.sender === ADMIN_LK ? props.theme.textColor : props.theme.white};

  a {
    color: #1677ff !important;

    :active {
      color: #1677ff !important;
    }
  }

  @media screen and (max-width: 480px) {
    width: fit-content;
    max-width: 60vw !important;
  }
`;

export const Item = styled.div`
  padding-bottom: 14px;

  ${MessageWrapper} {
    flex-direction: ${(props) =>
      props.sender === ADMIN_LK ? "row" : "row-reverse"};
  }

  ${MessageText} {
    color: ${(props) => (props.sender === ADMIN_LK ? "#000" : "#000")};
    background: ${(props) =>
      props.sender === ADMIN_LK
        ? "#DEEDFF"
        : "#FFCE00"};
  }

  ${ContentWrapper} {
    align-items: ${(props) =>
      props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
  }
`;

export const Image = styled(AntImage).attrs({
  alt: "img",
  preview: { mask: false },
})`
  width: 250px !important;
  aspect-ratio: 1 / 0.7;
  border-radius: 5px;
  object-fit: cover;
  cursor: pointer;

  @media screen and (max-width: 480px) {
    width: 60vw !important;
  }
`;

export const SpinWrapper = styled.div`
  padding: 14px;
  text-align: center;
`;

const styles = css`
  height: calc(100vh - 461px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media screen and (max-height: 830px) {
    height: calc(100vh - 366px);
  }
`;

export const InitialMessage = styled.div`
  ${(props) => props.size === "large" && styles}

  ${MessageText} {
    background-color: #DEEDFF;
    margin-top: 24px;
    border-radius: 16px;
  }
`;

// ========================================

/**
 * SendBox START
 */

export const SendContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 199;
`;

export const Box = styled.div`
  max-width: 448px;

  width: 100%;
  padding: 12px 0;
  padding-bottom: 8px;
  gap: 6px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: ${(props) => props.theme.backgroundColor};

  :nth-child(2) {
    flex: 1;
  }

  .ant-btn {
    background-color: #0378db !important;
    border-color: #0378db !important;

    :hover {
      border-color: #0378db !important;
    }

    svg {
      color: #fff;
    }
  }

  label {
    cursor: pointer;

    .anticon {
      font-size: 30px;
      color: gray;
    }
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const Input = styled(AntInput.TextArea)`
  max-height: 200px !important;
  border: 1px solid gray;
  border-radius: 20px;

  :hover {
    border: 1px solid gray;
  }
`;

/**
 * SendBox END
 */

// ========================================

/**
 * OptionBox START
 */

export const BoxWrapper = styled.div`
  position: relative;
  bottom: 0;
  border-radius: 12px;
  background-color: ${(props) => props.theme.white};
  padding: 0;
  padding-bottom: 12px;
  height: 530px;
`;

export const OptBox = styled(Row).attrs({
  gutter: [16, 8],
})`
  width: 100%;
  height: ${props => props.more ? "110px" : "100px"};
  overflow-y: auto;
  margin: 0 !important;
  background-color: #ffffff;
  padding: 12px;
  border-top: 1px solid #DEEDFF;
  
  svg {
    cursor: pointer;
  }
`;

export const Option = styled.div`
  padding: 3px 9px 0px 9px;
  border-radius: 18px;
  background-color: #0095DA;
  cursor: pointer;
  font-size: 11px;
  font-weight: normal;
  color: #fff;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const More = styled(Option)`
  background: #DEEDFF;
  color: #004F9C;
`;

/**
 * OptionBox END
 */

// ========================================

/***
 * SocialBox START
 */

export const SocialBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  color: #004F9C;
  font-size: 11px;
  font-weight: 400;
`;

export const SocialTitle = styled(Title)`
  color: #FFFFFF;
  padding-right: 18px;
`;

export const PhoneBox = styled(Space)`
  width: 100%;
  padding-top: 24px;

  .ant-space-item {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: #000;
  }

  > .ant-space-item:nth-child(2) {
    flex: 0;
  }

  .ant-divider {
    height: 30px !important;
    margin: 0 !important;
    border-inline-start: 2px solid #ecb2e9;
  }

  svg {
    width: 20px;
    height: 20px;
    padding-top: 5px;
  }

  @media screen and (max-width: 360px) {
    .ant-space-item {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 325px) {
    .ant-space-item {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 295px) {
    .ant-space-item {
      font-size: 10px;
    }
  }

  @media screen and (max-height: 800px) {
    padding-top: 12px;
  }
`;

export const SocialWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0095DA;
  padding: 8px;
  width: 100%;
  svg {
    width: 28px;
    height: 28px;
  }
  a {
    text-decoration: none !important;
  }
`;

export const PhoneWrapper = styled.div`
  width: 100%;
  background: #DEEDFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
  a {
    text-decoration: none !important;
  }
  div {
    display: flex;
    gap: 3px;
  }
`;

export const PhoneText = styled.p`
  color: #FFF;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 400;
  background: #0095DA;
  border-radius: 18px;
  padding: 0px 9px 0px 9px;
`;

export const SocialLink = styled.a`
  margin-right: 11px;

  @media screen and (max-width: 346px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const AdminAndTime = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
`;
